import React from "react";
import { Skeleton } from "@material-ui/lab";

export default function DashboardSkeleton(props) {
  const list = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  return list.map((item, i) => {
    return (
      <div className="move-container" key={i}>
        <div className="row mb-3">
          <div className="col-sm-12 col-md-4">
            <Skeleton height="4rem" variant="rect" animation="wave" />
          </div>
          <div className="col-sm-12 col-md-2">
            <Skeleton height="4rem" variant="rect" animation="wave" />
          </div>
          <div className="col-sm-12 col-md-4">
            <Skeleton height="4rem" variant="rect" animation="wave" />
          </div>
          <div className="col-sm-12 col-md-2">
            <Skeleton height="4rem" variant="rect" animation="wave" />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-8">
            <Skeleton height="2.5rem" variant="rect" animation="wave" />
          </div>
          <div className="col-sm-12 col-md-2">
            <Skeleton height="2.5rem" variant="rect" animation="wave" />
          </div>
          <div className="col-sm-12 col-md-2">
            <Skeleton height="2.5rem" variant="rect" animation="wave" />
          </div>
        </div>

        <hr />
      </div>
    );
  });
}
